import React from "react";
import { Calendar, Clock, LogOut } from "lucide-react";
import { useAppDispatch } from "../../shared/hooks";
import { logout } from "../../store/slices/authSlice";

const TheaterHeader = ({ userData, eventData }) => {
  const dispatch = useAppDispatch();

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString+ 'T00:00:00');
    return date.toLocaleDateString('es-AR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="mb-4 sm:mb-6 lg:mb-8 rounded-lg border bg-white text-gray-950 shadow-sm">
      <div className="p-4 sm:p-6">
        <div className="flex flex-col gap-4">
          {/* Header principal */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              {/* <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
                DANZAS REINA REECH
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Sistema de Reservas de Teatro
              </p> */}

              <img 
                src="/logoblanco-y-negro-header.png"
                alt="Logo"
                className="h-20 mb-4" 
              />
            </div>

            {/* Fecha y hora del evento y botón de salir */}
            <div className="flex items-center gap-4">
              {eventData && (
                <div className="flex items-center gap-4 text-sm sm:text-base">
                  <div className="flex items-center gap-2 text-gray-700">
                    <Calendar className="w-4 h-4 text-purple-600" />
                    <span className="capitalize">{formatDate(eventData.date)}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700">
                    <Clock className="w-4 h-4 text-blue-600" />
                    <span>{eventData.time}</span>
                  </div>
                </div>
              )}
              
              {/* Botón de salir */}
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                title="Salir y volver al login"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Salir</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TheaterHeader; 